import BaseModel from '../core/BaseModel'
export default class PackageModel extends BaseModel {
    constructor() {
        super({
            tableName: 'packages', label: " Danh Sách Gói Ứng Dụng", display_key: 'name',name: "packages",
        }, {
            stt: { 
              name: "stt", 
              label: "STT",
              class: 'center width_150 common',
              computed: (data, index) => {
                data.stt = index + 1;
              }
            },
            id: { 
              name: 'id', 
              type: "Uuid", 
              label: 'ID', 
              primaryKey: true,  
              display: false
            },
            name: {
                name: "name",
                type: "String",
                label: "Tên gói",
                filter: { type: "input", match: "contains" },
            },
            value: {
              name: "value",
              type: "String",
              label: "Thời hạn (ngày)",
              class: "center",
              filter: { type: "input", match: "contains" },
            },
            fee: {
              name: "fee",
              type: "Number",
              label: "Phí (đồng)",
              class: "right",
              filter: { type: "input", match: "contains" },
            },
            ordinal: {
              name: "ordinal",
              type: "Number",
              label: "Thứ tự",
              class: "center"
            },
            active: {
                name: "active",
                label: "Hiển thị",
                type: "Selection",
                custom: 'SelectionText',
                class: "center",
                options: [
                  { value: true, label: 'Có'},
                  { value: false, label: 'Không'},
                ],
                filter: {
                  type: 'select',
                  optionLabel: 'label',
                  optionKey: 'value',
                  match: 'equals'
                },
            },
            updated_by: {
                refs:"updated_by",
                type: "String",
                label: "Người cập nhật"
            },
            updated_at : {
              name: 'updated_at',
              type: "Datetime",
              label: 'Ngày cập nhật',
            },
        })
    }

}